/**
 * The Onboarding destination's address context (#2940): a customer account
 * and a portal. Only an id-shaped token is kept — a uuid on a live box, the
 * fixture's short keys (`g1`, `p-customer`) offline — and anything else is
 * dropped rather than passed on. The portal doors re-check every read either
 * way, so a forged id is theirs to refuse; this only keeps the address from
 * carrying text that is not an id at all.
 *
 * Its own module so the router can validate the address without pulling the
 * lazily loaded page into the main chunk.
 */
export const ONBOARDING_PATH = '/onboarding'

export interface OnboardingSearch { account?: string; portal?: string }

const ID = /^[A-Za-z0-9][A-Za-z0-9_-]{0,63}$/

export function validateOnboardingSearch(search: Record<string, unknown>): OnboardingSearch {
  const id = (value: unknown) => (typeof value === 'string' && ID.test(value) ? value : undefined)
  return { account: id(search.account), portal: id(search.portal) }
}
